import { render, staticRenderFns } from "./OwnersWebsiteRequests.vue?vue&type=template&id=566c98cd&scoped=true&"
import script from "./OwnersWebsiteRequests.vue?vue&type=script&lang=js&"
export * from "./OwnersWebsiteRequests.vue?vue&type=script&lang=js&"
import style0 from "./OwnersWebsiteRequests.vue?vue&type=style&index=0&id=566c98cd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566c98cd",
  null
  
)

export default component.exports